module.exports = __webpack_public_path__ + "img/avatar-10.a9fd7f08.jpg";